module.exports = __webpack_public_path__ + "static/media/3.cb78dd6d.jpg";